import { forEach, slice } from 'lodash';

import { getCookie } from '../../01-helpers/session-manager';
import { get as getPageOptions } from '../../01-helpers/utilities/options';

import getLatestCourses from '../../03-api/teetime/getlatestcourses';
import getCitiesAndCourses from '../../03-api/teetime/getcitiesandcourses';

import Autocomplete from '../../04-components/autocomplete/autocomplete';
import { ListItem } from '../../04-components/autocomplete/listItem';

const
    selectors = {
        coursesListId: '#coursesList',
        cityListId: '#cityList',
        storageKey: `MijnGolf_Auth`
    },
    category = {
        city: 'City',
        course: 'Course'
    },
    translationsKey = {
        key: 'translations',
        LatestCourses: 'LatestCourses',
        CityCourseError: 'CityCoursesError',
        LatestCoursesError: 'LatestCoursesError',
        GreenFeeOnly: 'GreenFeeOnly',
        BookingNotAllowed: 'BookingNotAllowed'
    },
    noOfCities = 10;

class PlaceSearch extends Autocomplete {

    constructor(baseElement) {
        super(baseElement);

        this.translations = getPageOptions(translationsKey.key);
    }

    _resetIds() {
        this.filterContext.update({
            'cityId': '',
            'courseId': '',
        });
    }

    /*================ EVENT HANDLERS ===============*/

    /**
     * 
     * @param {any} evt
     */
    _onFocusHandler(evt) {
        const golfCookie = getCookie(selectors.storageKey);
        // we do this by checking if the authentication cookie is set.
        if (!golfCookie) {
            return false;
        }

        const list = this.container.querySelector(selectors.coursesListId);

        list.innerHTML = '';
        // If we find the cookie we can then load the last played courses.
        getLatestCourses()
            .done(result => {
                if (result.Error || result.length <= 0) {
                    return false;
                }
                list.insertAdjacentHTML('afterbegin', `<div class="c-filter-list__title">${this.translations[translationsKey.LatestCourses]}</div>`);
                // add results to the result container
                forEach(result, city => {
                    let message = city.GreenFeeOnly ? this.translations[translationsKey.GreenFeeOnly] : '';
                    message = !city.AllowBooking ? this.translations[translationsKey.BookingNotAllowed] : message;

                    const listItem = new ListItem(city, city.Name, city.City, message, 'im-auto_suggest_course');
                    listItem.appendToElement(list);
                });
                // show the result container
                this.openContainer(this);
                this._setClickEvent(list);
            })
            .fail(error => {
                console.error(this.translations[translationsKey.LatestCoursesError]);
                this.closeContainer();
            });
    }

    _onKeyUpHandler(evt) {
        const element = evt.target,
            value = element.value;

        if (value.length >= 3) {
            const data = {
                search: value
            },
                list = this.container.querySelector(selectors.cityListId);

            this._resetIds();

            // call getCities API
            getCitiesAndCourses(data)
                .done(results => {
                    list.innerHTML = '';
                    forEach(results, (result, title) => {
                        if (result === null) {
                            return;
                        }

                        // if we receive an error, we stop with the autocomplete
                        list.insertAdjacentHTML('beforeend', `<li class="c-filter-list__title unselectable">${this.translations[title]}</div>`);
                        if (result.Error || result.length <= 0) {
                            list.insertAdjacentHTML('beforeend', `<li class="c-filter-list__info unselectable">${this.translations[title + "NotFound"]}</div>`);
                        } else {

                            const items = slice(result, 0, noOfCities);
                            // add results to the result container
                            forEach(items, course => {
                                let message = course.GreenFeeOnly ? this.translations[translationsKey.GreenFeeOnly] : '';
                                message = !course.AllowBooking ? this.translations[translationsKey.BookingNotAllowed] : message;
                                const listItem = (title === category.city) ? new ListItem(course, course.Name, course.Province, '', 'im-map') : new ListItem(course, course.Name, course.City, message, 'im-auto_suggest_course', `{"data-selection-id":"courseId"}`);
                                listItem.appendToElement(list);
                            });
                            // add results to the result container
                            this._setClickEvent(list);
                        }
                    });

                    // show the result container if it is not visible yet.
                    this.openContainer();
                })
                .fail(error => {
                    console.error(this.translations[translationsKey.CityCourseError]);
                });
        }
    }
}

export { PlaceSearch as PlaceSearch };